<template lang="pug">
  .error_explanation(v-if="errors && errors.length")
    strong {{ $t("components.form_errors_wrapper.errors") }}
    ul
      li(v-for="error in errors") {{ error }}

</template>

<script>

export default {
  props: {
    errors: Array
  }
}
</script>
